import React from 'react';
import { Container } from 'react-bootstrap';
import styled from 'styled-components'
import Title from './shared/Title'
import img from './assets/dave-and-dad.jpg'
import {media} from './util/media-queries'

const Image = styled.img`
  width: 100%;
  height: auto;
  box-sizing: border-box;
`

const HalfCol = styled.div`
  ${media.mobile`
    width: 100%;
  `}
  ${media.tablet`
    width: 50%;
    padding-right: 50px;
  `}
`

const ImageWrapper = styled.div`
  padding: 9px;
  border: 5px solid #fff;
  ${media.tablet`
    margin: 0px 0 0 30px;
  `}
`

const ContentContainer = styled.div`
  display: flex;
  ${media.mobile`
    flex-direction: column;
  `}
  ${media.tablet`
    flex-direction: row;
  `}
`

const ImgLabel = styled.label`
  float: right;
  font-size: 12px;
  margin-top: 6px;
`

const Divider = styled.div`
  width: 15%;
  height: 2px;
  background-color: #1EBBD7;
  margin-top: 20px;
  margin-bottom: 10px;
`

const Why = () => {
  return (
    <section id="why">
      <Container >
        <br />
        <Title title="Why I'm Climbing" />
        <br />
        <ContentContainer>
          <HalfCol className="about-wrapper__info">
            <p className="about-wrapper__info-text">
              In April 2019, my family was blindsided by my dad's surprise cancer diagnosis. Before the end of June — less than three months later — he was gone. 
            </p>
            <p className="about-wrapper__info-text">
              My dad was one of the strongest people I know; he was a fighter. But unfortunately for him — and so many others — cancer was a battle that could not be won, no matter how hard you fight.  
            </p>
            <p className="about-wrapper__info-text">
              My dad was influential to me in so many ways, but in particular, he passed down a love of travel and learning — experiencing new and unfamiliar cultures, places, and people. I'm extremely fortunate to have visited six of the seven continents with him.
            </p>
            <p className="about-wrapper__info-text">
              My dad and I got to wander through the ruins of Machu Picchu and relax in the thermal baths of Budapest in winter. We sampled curries throughout India, threw boomerangs in Australia, and shared a boat cabin on our way to wander among the penguins on the Antarctic Peninsula.
            </p>
            <Divider />
            <p className="about-wrapper__info-text">
              <span style={{ fontWeight: 600 }}>
               Africa would have been our seventh continent to explore together, so it's fitting that the Kilimanjaro Climb will bring me to Tanzania to help raise money to help conquer cancer.
             </span>
            </p>
            <br />
          </HalfCol>
          <HalfCol>
            <div>
              <ImageWrapper>
                <Image src={img} alt="With Dad in Antarctica" />
              </ImageWrapper>
              <ImgLabel>Antarctica, January 2015</ImgLabel>
            </div>
          </HalfCol>
        </ContentContainer>
      </Container>
    </section>
  );
};

export default Why;
